import { Injectable } from '@angular/core';

import { KeyValuePair } from '@reg/shared/model';

/**
 * Service for getting the toRegistrantGroupTypes
 */
@Injectable()
export class ToRegistrantGroupTypeService {
    // Consts are a copy of the RegistrationType enum defined in the floarena-api
    public static NA: string = 'na';
    public static EVERYONE: string = 'everyone';
    public static ME: string = 'me';
    public static INVITED_TEAMS: string = 'invited-teams';
    public static INVITED_TEAMS_PAID: string = 'invited-teams-paid';
    public static INVITED_TEAMS_NOT_PAID: string = 'invited-teams-not-paid';
    public static INVITED_TEAMS_NO_PARTICIPANTS: string = 'invited-teams-no-participants';
    public static PARTICIPANTS_AND_PARENTS: string = 'participants-parents';
    public static PARTICIPANTS_AND_PARENTS_PAID: string = 'participants-parents-paid';
    public static PARTICIPANTS_AND_PARENTS_NOT_PAID: string = 'participants-parents-not-paid';

    public static PARTICIPANTS_AND_PARENTS_IN_PROGRESS: string = 'participants-parents-in-progress';

    private types: KeyValuePair[] = [];

    /**
     * Constructor. Build enum list
     */
    constructor() {
        this.types.push(new KeyValuePair(ToRegistrantGroupTypeService.EVERYONE, 'Everyone'));
        this.types.push(new KeyValuePair(ToRegistrantGroupTypeService.ME, 'Me Only (Test)'));
        this.types.push(new KeyValuePair(ToRegistrantGroupTypeService.INVITED_TEAMS, 'Invited Teams'));
        this.types.push(new KeyValuePair(ToRegistrantGroupTypeService.INVITED_TEAMS_PAID, 'Invited Teams Paid'));
        this.types.push(new KeyValuePair(
            ToRegistrantGroupTypeService.INVITED_TEAMS_NOT_PAID,
            'Invited Teams Not Paid',
        ));
        this.types.push(new KeyValuePair(
            ToRegistrantGroupTypeService.INVITED_TEAMS_NO_PARTICIPANTS,
            'Invited Teams Without Participants',
        ));
        this.types.push(new KeyValuePair(
            ToRegistrantGroupTypeService.PARTICIPANTS_AND_PARENTS,
            'Participants and/or Parents',
        ));
        this.types.push(new KeyValuePair(
            ToRegistrantGroupTypeService.PARTICIPANTS_AND_PARENTS_PAID,
            'Participants and/or Parents Paid',
        ));
        this.types.push(new KeyValuePair(
            ToRegistrantGroupTypeService.PARTICIPANTS_AND_PARENTS_NOT_PAID,
            'Participants and/or Parents Not Paid',
        ));
        this.types.push(new KeyValuePair(
            ToRegistrantGroupTypeService.PARTICIPANTS_AND_PARENTS_IN_PROGRESS,
            'Participants and/or Parents In Progress',
        ));
    }

    /**
     * Get all types
     */
    public getIndex(includeTeamInviteGroups: boolean): KeyValuePair[] {
        if (includeTeamInviteGroups) {
            return this.types;
        }

        return this.types.filter((x: KeyValuePair) =>
            x.key !== ToRegistrantGroupTypeService.INVITED_TEAMS &&
            x.key !== ToRegistrantGroupTypeService.INVITED_TEAMS_PAID &&
            x.key !== ToRegistrantGroupTypeService.INVITED_TEAMS_NOT_PAID &&
            x.key !== ToRegistrantGroupTypeService.INVITED_TEAMS_NO_PARTICIPANTS);
    }

    /**
     * Get a single type
     */
    public get(key: string): KeyValuePair {
        const foundTypes: KeyValuePair[] = this.types.filter((type: KeyValuePair) => type.key === key);

        if (foundTypes && foundTypes.length > 0) {
            // Found a match
            return foundTypes[0];
        }

        // No match found so construct a new one
        return new KeyValuePair(key, key);
    }
}
